import { Box, Button, FormControl, Grid, IconButton, Paper, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { ConvertDate } from "../../../Base/helper/baseFunctions";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import { useState } from "react";
import { DeleteExitRequestHelper, updateEmployeeLwdHelper } from "../../helper/EcmsHelper";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import { useSelector } from "react-redux";
import CustomRatingNew from "../../../Base/views/RatingNew";

const EmployeePreview = ({ closeMode, employeeRecord }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [isEditingLwd, setIsEditingLwd] = useState(false);
  const [newLwd, setNewLwd] = useState(employeeRecord?.lwd || null);
  const { minDojYear } = useSelector(
    (state) => state?.AncillaryReducer?.WorkSpaceDojReducer
  );
  const handleDelete = () => {
      DeleteExitRequestHelper({employee_fk: employeeRecord?.employee_id,
            entry_type: "rejected"}).then((res) => {
        if(res?.data?.statuscode === 200) {
          setOpenDialog(false);
          closeMode(true);
        }
      })
  } 
const handleLwdSubmit = () => {
    updateEmployeeLwdHelper({
      employee_fk: employeeRecord?.employee_id,
      lwd: newLwd,
    }).then((res) => {
      if (res?.hasError === false) {
        setIsEditingLwd(false);
        closeMode(true);
      }
    });
  };
  return (
    <>
      <Box>
        <Box display={"flex"} justifyContent={"space-between"} alignItems={"end"} mb={2}>
          <Typography variant="subtitle1" fontWeight={"600"} gutterBottom>
            Employee Details
          </Typography>
          <Button variant="outlined" color="primary"
            sx={{
              "&:hover": {
                borderColor: (theme) => theme.palette.error.main,
                color: (theme) => theme.palette.error.main,
              },
            }}
            onClick={() => setOpenDialog(true)}
            >
              Reject Request
          </Button>
        </Box>
        <Box
          sx={{
            px: 3,
            py: 2,
            mb: 2,
            borderRadius: 2,
            backgroundColor: "#f4f2f7",
            border: "1px solid #E0E0E0",
          }}
        >
          <Grid container spacing={1.5}>
            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                Employee Name
              </Typography>
              <Typography fontWeight={500}>
                {employeeRecord?.name || "-"}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                Date of Joining
              </Typography>
              <Typography fontWeight={500}>
                {ConvertDate(employeeRecord?.doj) || "-"}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                Resignation Date
              </Typography>
              <Typography fontWeight={500}>
                {ConvertDate(employeeRecord?.resignation_date) || "-"}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                Last Working Date
              </Typography>
              <Box display="flex" alignItems="center">
                {!isEditingLwd ? (
                  <>
                    <Typography fontWeight={500}>
                      {ConvertDate(employeeRecord?.lwd) || "-"}
                    </Typography>
                    <IconButton
                      size="small"
                      sx={{ ml: 1 }}
                      onClick={() => setIsEditingLwd(true)}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </>
                ) : (
                  <Box mt={0.5}>
                    <FormControl sx={{width: 150}}>
                      <CommonDatePicker
                        size="small"
                        name="dob"
                        pickerType="date"
                        onKeyDown={(e) => e.preventDefault()}
                        onKeyPress={(e) => e.preventDefault()}
                        pickerFormat="dd/MM/yyyy"
                        DefaultDTvalue={newLwd}
                        minDate={new Date(new Date(minDojYear).getFullYear(), 0, 31)}
                        maxDate={new Date(new Date().getFullYear() + 1, 11, 31)}
                        handleChange={(value) =>
                          setNewLwd(value ? `${
                                    value?.getFullYear() +
                                    "-" +
                                    ("0" + (value?.getMonth() + 1)).slice(-2) +
                                    "-" +
                                    ("0" + value?.getDate()).slice(-2)
                                  }`
                                : "")
                        }
                      />
                    </FormControl>
                    <IconButton
                      size="small"
                      color="success"
                      sx={{ ml: 1 }}
                      onClick={handleLwdSubmit}
                    >
                      <CheckIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => {
                        setIsEditingLwd(false);
                        setNewLwd(employeeRecord?.lwd || null);
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>
                )}
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                Employee Feedback
              </Typography>
              <Typography fontWeight={500}>
                  {employeeRecord?.feedback_text ||
                  "-"}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                Rating
              </Typography>
              {employeeRecord?.feedback_no ? (
                <CustomRatingNew
                      max={10}
                      name={"feedback_no"}
                      value={employeeRecord?.feedback_no}
                      readonly={true}
                    />
              ) : (
                <Typography fontWeight={500}>
                  -
              </Typography>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>
      {employeeRecord?.clearance_json?.length > 0 && (
        <Box>
          <Typography variant="subtitle1" fontWeight={"600"} gutterBottom>
            Asset Clearance Status
          </Typography>
          <Box
            sx={{
              borderRadius: 2,
              backgroundColor: "#f4f2f7",
              border: "1px solid #E0E0E0",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                px: 1,
                minHeight: "160px",
                maxHeight: "40vh",
                overflowY: "auto",
              }}
            >
              {employeeRecord?.clearance_json?.map((item, index) => (
                <Paper key={index} sx={{ p: 2, my: 2 }} elevation={3}>
                  <InfoRow
                    label="Clearance Type"
                    value={item?.clearance_type}
                  />
                  <InfoRow
                    label="Approver"
                    value={item?.clearance_approver_name}
                  />
                  <InfoRow label="Approved" value={item?.approver_status} />
                  <InfoRow label="Approved Date" value={item?.approver_date} />
                  <InfoRow
                    label="Approver Comment"
                    value={item?.approver_comments}
                  />
                </Paper>
              ))}
            </Box>
          </Box>
        </Box>
      )}
      {employeeRecord?.ecms_adjustment_json?.length > 0 && (
        <Box mt={2}>
          <Typography variant="subtitle1" fontWeight={"600"} gutterBottom>
            Adjustment Status
          </Typography>
          <Box
            sx={{
              borderRadius: 2,
              backgroundColor: "#f4f2f7",
              border: "1px solid #E0E0E0",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                px: 1,
                minHeight: "200px",
                maxHeight: "40vh",
                overflowY: "auto",
              }}
            >
              {employeeRecord?.ecms_adjustment_json?.map((item, index) => (
                <Paper key={index} sx={{ p: 2, my: 2 }} elevation={3}>
                  <InfoRow
                    label="Adjustment"
                    value={item?.component_json?.label}
                  />
                  <InfoRow label="Approver" value={item?.component_json?.approver_name} />
                  <InfoRow
                    label="Submitted Date"
                    value={
                      item?.record_date ? ConvertDate(item?.record_date) : "-"
                    }
                  />
                  <InfoRow label="Submitted Amount" value={item?.amount} />
                  <InfoRow
                    label="Approved Date"
                    value={
                      item?.component_json?.approver_date
                        ? ConvertDate(item?.component_json?.approver_date)
                        : "-"
                    }
                  />
                  <InfoRow
                    label="Approved Amount"
                    value={item?.component_json?.approver_amount}
                  />
                  <InfoRow
                    label="Approver Comment"
                    value={item?.component_json?.approver_comments}
                  />
                </Paper>
              ))}
            </Box>
          </Box>
        </Box>
      )}
      <ConfirmationDialog
            title="Reject Resignation"
            content={"Are you sure you want to reject this employee's resignation request? This action cannot be undone."}
            openDialog={openDialog}
            closeDialog={setOpenDialog}
            OkButtonText="Yes"
            onSubmit={handleDelete}
        />
    </>
  );
};
const InfoRow = ({ label, value }) => {
  return (
    <Grid container spacing={1.5}>
      <Grid item xs={3.5}>
        <Typography variant="body2" color="textSecondary">
          {label}
        </Typography>
      </Grid>
      <Grid item xs={0.5}>
        <Typography>:</Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography fontWeight={500}>{value || "-"}</Typography>
      </Grid>
    </Grid>
  );
};

export default EmployeePreview;
